/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CurrencySelector_viewer = {
    readonly currencies: ReadonlyArray<string | null> | null;
    readonly " $refType": "CurrencySelector_viewer";
};
export type CurrencySelector_viewer$data = CurrencySelector_viewer;
export type CurrencySelector_viewer$key = {
    readonly " $data"?: CurrencySelector_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencies",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '5aac20400602302af5d4fb1956db667c';
export default node;
